import type { AgentTest, AgentTestStatus } from "./api";

/**
 * Las pruebas de «Probar» (D46) de un asistente, en el orden en que se mandaron. Viven sólo en la
 * pestaña: la API las borra a los 30 días y no hay listado, así que al cerrar el drawer se pierden.
 */
export type AccionDePrueba =
  | { tipo: "creada"; prueba: AgentTest }
  | { tipo: "actualizada"; prueba: AgentTest }
  | { tipo: "limpiar" };

const ABIERTAS: AgentTestStatus[] = ["pending", "running"];

/** Ya contestada, fallida o vencida: no hay más que esperar. */
export const terminada = (status: AgentTestStatus) =>
  !ABIERTAS.includes(status);

export function pruebasReducer(
  pruebas: AgentTest[],
  accion: AccionDePrueba,
): AgentTest[] {
  switch (accion.tipo) {
    case "creada":
      return pruebas.some((p) => p.testId === accion.prueba.testId)
        ? pruebas
        : [...pruebas, accion.prueba];
    case "actualizada":
      return pruebas.map((p) =>
        // Una lectura vieja que llega tarde no hace volver a esperar a una que ya terminó.
        p.testId === accion.prueba.testId &&
        !(terminada(p.status) && !terminada(accion.prueba.status))
          ? accion.prueba
          : p,
      );
    case "limpiar":
      return [];
  }
}

/** Las que hay que volver a leer. */
export const pendientes = (pruebas: AgentTest[]) =>
  pruebas.filter((p) => !terminada(p.status)).map((p) => p.testId);

/** Lo que se ve mientras no hay respuesta, o en lugar de ella. */
export function textoDelEstado(
  p: Pick<AgentTest, "status" | "error">,
): string | null {
  switch (p.status) {
    case "pending":
      return "Esperando al asistente…";
    case "running":
      return "El asistente está respondiendo…";
    case "expired":
      return "No respondió a tiempo: el pod no estaba en línea o no la pudo correr.";
    case "failed":
      return p.error ? `Falló: ${p.error}` : "Falló la prueba.";
    default:
      return null;
  }
}
